import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/app/cycle/$cycleId/survey/onboarding/$surveyId/')({
  beforeLoad: ({
    params
  }) => {
    // intro 페이지로 리디렉션
    throw redirect({
      to: '/app/cycle/$cycleId/survey/onboarding/$surveyId/pages/intro',
      params: {
        cycleId: params.cycleId,
        surveyId: params.surveyId
      }
    });
  }
});